import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';


@Injectable()
export class FileUploadService {
    private http: HttpClient;
    constructor(@Inject(HttpClient) http: HttpClient) {
        this.http = http;
    }

    uploadFile(url: string, event: any): Observable<any> {

        let url_ = url.replace(/[?&]$/, '');

        let formData_ = new FormData();

        for (const file of event.files) {
            formData_.append('file', file, file.name);
        }

        let opts_: any = {
            observe: 'response',
            responseType: 'json',
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + abp.auth.getToken(),
                'Accept': 'application/json'
            })
        };

        return this.http.post(url_, formData_, opts_);
    }
}
